import { Asterisk } from "lucide-react";
import { SITE } from "@/config/site";

const colors = ["#FACC15", "#84CC16", "#FF5566", "#FFFFFF", "#FF5500"];

export const Marquee = () => {
  const items = [...SITE.skills, ...SITE.skills];
  return (
    <div data-testid="skills-marquee" className="relative overflow-hidden">
      <div className="bg-[#0055FF] py-5">
        <div className="anim-marquee flex w-max gap-8">
          {items.map((s, i) => (
            <span key={i} className="flex items-center gap-8 whitespace-nowrap font-display text-2xl font-extrabold text-white sm:text-3xl">
              {s} <Asterisk className="h-7 w-7" style={{ color: colors[i % colors.length] }} />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
